import DrawPolygons from "./polygon";
import {intersectionObserve} from "./_intersection-observer";

const $block = $('.field-units-hero');

if($block && $block.length > 0) {

  var $stickyHeader = $block.find('.sticky-info');
  var $banner = $block.find('.banner-info >.title');
  var $backToUnitSelector = $block.find('.back-to-unit-selector');

  if ($banner.length > 0) {
      intersectionObserve($banner[0], 0, function(element, intersectionRatio) {
          if (intersectionRatio > 0) {
              $stickyHeader.removeClass('show small');
              $backToUnitSelector.removeClass('fade');
          } else {
              $stickyHeader.addClass('show');
              $backToUnitSelector.addClass('fade show');
          }
      });

      $(window).scroll(function() {
          var scrollTop = $(this).scrollTop();

          if (scrollTop < $banner.height()) {
              $stickyHeader.removeClass('show');
              $backToUnitSelector.removeClass('fade');
          }
      });
  }

  let $closeBtn = $block.find('.close-modal');
  const $unitDetails = $block.find('.subfield-units .unit-details');
  
  $closeBtn.click(function(e) {
    let $unit = $closeBtn.parents('.unit-detail');
    $block.find('.overlay').removeClass('show');
    $unitDetails.removeClass('anim');
    setTimeout(function() {
      $unitDetails.removeClass('show');
    }, 300);
    $unitDetails.find('.unit-detail').hide();
    $unit.removeClass('show');
    $unit.hide();
    $unitDetails.removeClass('open');
    if($block.find('.preview svg polygon.highlighted')) {
      $block.find('.preview svg polygon.highlighted').removeClass('highlighted');
    }
    $('body').removeClass('no-scroll');

  });

  function showUnit(unitId) {
      var $unitDetails = $block.find('.unit-details');
      var $unit = $unitDetails.find('#' + unitId);
      $block.find('.overlay').addClass('show');
      $unitDetails.addClass('show');
      setTimeout(function() {
        $unitDetails.addClass('anim');
      }, 10);
      $unitDetails.find('.unit-detail').hide();
      $unit.show();
      $unitDetails.addClass('open');
      $block.find('.preview svg polygon[data-id=' + unitId + ']').addClass('highlighted');


      if(window.innerWidth >= 600) {
        $('body').addClass('no-scroll');
      }


      if(window.innerWidth < 600) {
        $('html, body').animate({
          scrollTop: $unit.offset().top - 130
        }, 300);
      }
  }

  var $polygons = $block.find('.preview polygon');
  $polygons.click(function(e) {
    if (!$(this).hasClass('available')) {
      return;
    }

    var unitId = $(this).data('id');
    showUnit(unitId);

    if (history.pushState) {
      history.pushState(null, null, '#' + unitId);
    }
  });

  if (window.location.hash) {
      let id = window.location.hash.substring(1);
      if ($('#' + id).hasClass('unit-detail')) {
        showUnit(id);
      }
  }

  $polygons.hover(function(e) {
    if (!($(this).hasClass('upcoming') || $(this).hasClass('sold'))) {
      return;
    }
    const tooltip = document.getElementById('unit-tooltip');
    const tooltipText = this.getAttribute('data-tooltip-text');
    tooltip.textContent = tooltipText;

     // Get the bounding box of the polygon
    const bbox = this.getBBox();
    const svg = this.ownerSVGElement;
    const pt = svg.createSVGPoint();
    
    // Calculate center of the polygon
    pt.x = bbox.x + bbox.width / 2;
    pt.y = bbox.y + bbox.height / 2;
    
    // Convert SVG coordinates to screen coordinates
    const screenPt = pt.matrixTransform(svg.getScreenCTM());
    
    // Position tooltip at center of polygon
    tooltip.style.left = screenPt.x + 'px';
    tooltip.style.top = screenPt.y + 'px';

    tooltip.classList.add('show');

  },
  function(e) {
    const tooltip = document.getElementById('unit-tooltip');
    tooltip.classList.remove('show');
  })

  let $titleTooltips = $block.find('.unit-title-tooltip');
  if($titleTooltips.length > 0) {
    $titleTooltips.each(function() {
      const unitId = $(this).attr('data-id');
      const unitPolygon = $block.find('.preview svg polygon[data-id=' + unitId + ']');
      if(unitPolygon.hasClass('available')) {
        calculatePolygonCenter(this, unitPolygon);
      }
    });
  }

  window.addEventListener('resize', function() {
    if($titleTooltips.length > 0) {
      $titleTooltips.each(function() {
        const unitId = $(this).attr('data-id');
        const unitPolygon = $block.find('.preview svg polygon[data-id=' + unitId + ']');
        if(unitPolygon.hasClass('available')) {
          calculatePolygonCenter(this, unitPolygon);
        }
      });
    }
  });

  function calculatePolygonCenter(unit, unitPolygon) {
    const polygon = unitPolygon[0];
  
    // Get bounding rect in viewport coordinates
    const rect = polygon.getBoundingClientRect();
    
    // Calculate center
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 3.5;

    let adminBarHeight = 0;
    if(document.querySelector('body').classList.contains('admin-bar')) {
      if(window.innerWidth > 782) {
        adminBarHeight = 32;
      }
      else {
        adminBarHeight = 46;
      }
    }
    unit.style.left = (centerX + window.scrollX) + 'px';
    unit.style.top = (centerY + window.scrollY - adminBarHeight) + 'px';
    unit.classList.add('show');
  }

  window.addEventListener('click', function(e) {
    if ((e.target.closest('.overlay')) && $unitDetails.hasClass('show')) {
      let $unit = $block.find('.unit-details .unit-detail.show');
      $block.find('.overlay').removeClass('show');
      $unitDetails.removeClass('anim');
      setTimeout(function() {
        $unitDetails.removeClass('show');
      }, 300);
      $unitDetails.find('.unit-detail').hide();
      $unit.hide();
      $unitDetails.removeClass('open');
      if($block.find('.preview svg polygon.highlighted')) {
        $block.find('.preview svg polygon.highlighted').removeClass('highlighted');
      }
      $('body').removeClass('no-scroll');
    }
  });
}

let polygon = new DrawPolygons();

function slugify(title) {
  var str = title;
  str = str.replace(/^\s+|\s+$/g, ''); // trim
  str = str.toLowerCase();

  // remove accents, swap ñ for n, etc
  var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
  var to   = "aaaaeeeeiiiioooouuuunc------";
  for (var i=0, l=from.length ; i<l ; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }

  str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
      .replace(/\s+/g, '-') // collapse whitespace and replace by -
      .replace(/-+/g, '-'); // collapse dashes

    return str;
  }

  polygon.setPolygonCallback(function (data) {
    if (!data.polyName) {
      return;
    }

    // Update input field with new points
    var $inputs = $('[data-key="field_68c92a7fdbf17"] input');
    var polygonFieldInputId = data.polyIndex === 0 ? '68c92a7fdea92' : '68c92a7fdeea8'

    for (var i = 0; i < $inputs.length; i++) {
      var $input = $($inputs[i]);

      if ($input.val() === data.polyName || $input.attr('value') === data.polyName) {
        $input.parents('.acf-row')
            .find('.acf-field-' + polygonFieldInputId + ' input')
            .val(data.points)
            .attr('value', data.points);
      }
    }

    $( ".acf-block-fields" ).each(function(  ) {
        var evt = document.createEvent("HTMLEvents");
        evt.initEvent("change", false, true);
        $(this)[0].dispatchEvent(evt);
    });
  });

  function setupFieldEditingHero(svgId) {
      polygon.setAllowEditing(true);
      polygon.editPolygon(svgId, 'random');
      polygon.setCircleRadius(8);
  }

  window.setupFieldEditingHero = setupFieldEditingHero;

  function startPolygonDrawingHero(el, index) {
      var $svg = $('.block-editor-block-list__block.is-selected .preview > svg');
      var name = $(el).parents('.acf-row').find('[data-name="title"] input').val();
      var slug = slugify(name);

      polygon.drawPolygon($svg.attr('id'), slug + '-' + index, name, index);
  }

  window.startPolygonDrawingHero = startPolygonDrawingHero;